import classNames from 'classnames';
import * as style from './Breadcrumbs.module.less';

export interface BreadcrumbItem {
    label: string;
    onClick?: () => void;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    className?: string;
}

export const Breadcrumbs = (p: BreadcrumbsProps) => {
    return (
        <div className={classNames(style.breadcrumbs, p.className)}>
            {p.items.map((item, index) => {
                const isCurrent = index === p.items.length - 1;
                return (
                    <div
                        key={`${item.label}-${index}`}
                        style={{ display: 'contents' }}
                    >
                        {index > 0 && (
                            <svg
                                className={classNames(style.divider, {
                                    [style.dividerCurrent]: isCurrent
                                })}
                                width="6.076"
                                height="12.712"
                                viewBox="0 0 6.076 12.712"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M6.076 12.712H5.026L0 0H1.05L6.076 12.712Z"
                                    fill="currentColor"
                                />
                            </svg>
                        )}
                        {isCurrent || !item.onClick ? (
                            <span
                                className={classNames(style.crumb, {
                                    [style.crumbCurrent]: isCurrent
                                })}
                                aria-current={isCurrent ? 'page' : undefined}
                            >
                                {item.label}
                            </span>
                        ) : (
                            <button
                                type="button"
                                className={classNames(
                                    style.crumb,
                                    style.crumbLink
                                )}
                                onClick={item.onClick}
                            >
                                {item.label}
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
